import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Lightning.svg",
  "use": "Lightning.svg-usage",
  "viewBox": "0 0 10 16",
  "content": "<symbol viewBox=\"0 0 10 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Lightning.svg\">\n<path d=\"M6.70705 0H2.57747C2.39746 0 2.23962 0.120253 2.19183 0.293812L0.139379 7.74778C0.0692537 8.00246 0.260872 8.25397 0.525026 8.25397H4.09091L2.12727 14.9466C2.06463 15.16 2.34501 15.3009 2.4789 15.1232L9.51715 5.78359C9.71578 5.52001 9.52774 5.14286 9.1977 5.14286H5.45455L7.08418 0.533327C7.1762 0.273044 6.98312 0 6.70705 0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol